// Code generated by go run pkg/apigen/generate. DO NOT EDIT.

import useSWR, { SWRConfiguration, SWRResponse } from "swr";

import * as enums from "~src/shared/enums";
import * as routerTypes from "~src/public/apigen/types";
import * as globalTypes from "~src/shared/apigen/types";
import { fetchRPCRoute } from "~src/shared/apigen/framework";
import { FieldValidationError, RPCError, IRPCErrorOptions } from "~src/shared/errors/taxonomy";

export type IPublicGetUserReturn = {
  id: number | null;
  roomID: number | null;
  type: enums.IUserTypeEnum | null;
};

export const publicGetUser = async (
): Promise<IPublicGetUserReturn> => {
  return await fetchRPCRoute({
    method: "POST",
    router: "public",
    routePath: "GetUser",
    args: undefined,
    errors: [
    ],
  });
};

export const usePublicGetUser = (
  config?: SWRConfiguration & {
    // If true, the hook will not fetch. Data will be null.
    blockFetch?: boolean,
    // This value will be included in the cache key. Pass different values to force cache
    // invalidation.
    refetchNonce?: number | string,
  },
): SWRResponse<IPublicGetUserReturn, RPCError> => {
  return useSWR(
    config?.blockFetch === true ? null : ["/public/GetUser", config?.refetchNonce],
    publicGetUser,
    config,
  );
};
